"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.uniqueWalletsByLabel = exports.initializeWalletModules = exports.setWalletModules = exports.resetStore = exports.updateAccount = exports.setPrimaryWallet = exports.removeWallet = exports.updateWallet = exports.addWallet = exports.addChains = void 0;
var configuration_1 = require("../configuration");
var validation_1 = require("../validation");
var constants_1 = require("./constants");
var index_1 = require("./index");
function addChains(chains) {
    // chains are validated on init
    var action = {
        type: constants_1.ADD_CHAINS,
        payload: chains.map(function (_a) {
            var _b = _a.namespace, namespace = _b === void 0 ? 'evm' : _b, id = _a.id, rest = __rest(_a, ["namespace", "id"]);
            return (__assign(__assign({}, rest), { namespace: namespace, id: id.toLowerCase() }));
        })
    };
    (0, index_1.dispatch)(action);
}
exports.addChains = addChains;
function addWallet(wallet) {
    var error = (0, validation_1.validateWallet)(wallet);
    if (error) {
        console.error(error);
        throw error;
    }
    var action = {
        type: constants_1.ADD_WALLET,
        payload: wallet
    };
    (0, index_1.dispatch)(action);
}
exports.addWallet = addWallet;
function updateWallet(id, update) {
    var error = (0, validation_1.validateWallet)(update);
    if (error) {
        console.error(error);
        throw error;
    }
    var action = {
        type: constants_1.UPDATE_WALLET,
        payload: __assign({ id: id }, update)
    };
    (0, index_1.dispatch)(action);
}
exports.updateWallet = updateWallet;
function removeWallet(id) {
    var error = (0, validation_1.validateString)(id, 'wallet id');
    if (error) {
        throw error;
    }
    var action = {
        type: constants_1.REMOVE_WALLET,
        payload: {
            id: id
        }
    };
    (0, index_1.dispatch)(action);
}
exports.removeWallet = removeWallet;
function setPrimaryWallet(wallet, address) {
    var error = (0, validation_1.validateWallet)(wallet) || (address && (0, validation_1.validateString)(address, 'address'));
    if (error) {
        throw error;
    }
    // if also setting the primary account
    if (address) {
        var account_1 = wallet.accounts.find(function (ac) { return ac.address === address; });
        if (account_1) {
            wallet.accounts = __spreadArray([
                account_1
            ], wallet.accounts.filter(function (_a) {
                var address = _a.address;
                return address !== account_1.address;
            }), true);
        }
    }
    // add wallet will set it to first wallet since it already exists
    addWallet(wallet);
}
exports.setPrimaryWallet = setPrimaryWallet;
function updateAccount(id, address, update) {
    var action = {
        type: constants_1.UPDATE_ACCOUNT,
        payload: __assign({ id: id, address: address }, update)
    };
    (0, index_1.dispatch)(action);
}
exports.updateAccount = updateAccount;
function resetStore() {
    var action = {
        type: constants_1.RESET_STORE
    };
    (0, index_1.dispatch)(action);
}
exports.resetStore = resetStore;
function setWalletModules(wallets) {
    var error = (0, validation_1.validateWalletInit)(wallets);
    if (error) {
        throw error;
    }
    var modules = initializeWalletModules(wallets);
    var dedupedWallets = uniqueWalletsByLabel(modules);
    var action = {
        type: constants_1.SET_WALLET_MODULES,
        payload: dedupedWallets
    };
    (0, index_1.dispatch)(action);
}
exports.setWalletModules = setWalletModules;
// ==== HELPERS ==== //
function initializeWalletModules(modules) {
    var device = configuration_1.configuration.device;
    return modules.reduce(function (acc, walletInit) {
        // @ts-ignore - it's actually correct
        var initialized = walletInit({ device: device });
        if (initialized) {
            // injected wallets is an array of wallets
            acc.push.apply(acc, (Array.isArray(initialized) ? initialized : [initialized]));
        }
        return acc;
    }, []);
}
exports.initializeWalletModules = initializeWalletModules;
function uniqueWalletsByLabel(walletModuleList) {
    return walletModuleList.filter(function (wallet, i) {
        return walletModuleList.findIndex(function (innerWallet) { return innerWallet.label === wallet.label; }) === i;
    });
}
exports.uniqueWalletsByLabel = uniqueWalletsByLabel;
